import coxsBazar from './Images/Sajek.png';
import sreemangal from './Images/Sreemongol.png';
import sundarban from './Images/sundorbon.png';


let fakeData = [
    {
        key:'B104LC',
        name: "COX'S BAZAR",
        description:"Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...",
        image: coxsBazar
    },{
        key:'B104Ld',
        name: "SREEMANGAL",
        description:"Sreemangal (Bengali: শ্রীমঙ্গল, romanized: Srimongol) is an Upazila of Moulvibazar District in the Sylhet Division of Bangladesh.",
        image:sreemangal
    },
    {
        key:'B104Le',
        name: "SUNDARBANS",
        description:"The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from ...",
        image:sundarban
    }
]
export default fakeData;